// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DO NOT EDIT
@todo This file is copied from GUI and should be pulled out into a shared library.
See https://github.com/LLK/scratch-paint/issues/13 */

/* 35% transparent version of looks-secondary */

.dropdown_dropdown_fEG8z {
  border: 1px solid var(--paint-form-border, #e9eef2);
  border-radius: 5px;
  overflow: visible;
  min-width: 3.5rem;
  color: var(--paint-looks-secondary, #855cd6);
  padding: 0.5rem;
}

.dropdown_mod-open_Dnwvi {
  background-color: var(--paint-form-border, #e9eef2);
}

.dropdown_dropdown-icon_OMoXu {
  width: 0.5rem;
  height: 0.5rem;
  vertical-align: middle;
  padding-bottom: 0.2rem;
}

[dir='ltr'] .dropdown_dropdown-icon_OMoXu {
  margin-left: 0.5rem;
}

[dir='rtl'] .dropdown_dropdown-icon_OMoXu {
  margin-right: 0.5rem;
}

.dropdown_mod-caret-up_NUicY {
  -webkit-transform: rotate(180deg);
      -ms-transform: rotate(180deg);
          transform: rotate(180deg);
  padding-bottom: 0;
  padding-top: 0.2rem;
}
`, "",{"version":3,"sources":["webpack://./../scratch-paint/src/components/dropdown/dropdown.css"],"names":[],"mappings":"AAAA;;oDAEoD;;AAEpD,+CAA+C;;AAE/C;EACE,mDAAmD;EACnD,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;MAC7B,6BAA6B;UACzB,yBAAyB;EACjC,iBAAiB;EACjB,mBAAmB;AACrB","sourcesContent":["/* DO NOT EDIT\n@todo This file is copied from GUI and should be pulled out into a shared library.\nSee https://github.com/LLK/scratch-paint/issues/13 */\n\n/* 35% transparent version of looks-secondary */\n\n.dropdown {\n  border: 1px solid var(--paint-form-border, #e9eef2);\n  border-radius: 5px;\n  overflow: visible;\n  min-width: 3.5rem;\n  color: var(--paint-looks-secondary, #855cd6);\n  padding: 0.5rem;\n}\n\n.mod-open {\n  background-color: var(--paint-form-border, #e9eef2);\n}\n\n.dropdown-icon {\n  width: 0.5rem;\n  height: 0.5rem;\n  vertical-align: middle;\n  padding-bottom: 0.2rem;\n}\n\n[dir='ltr'] .dropdown-icon {\n  margin-left: 0.5rem;\n}\n\n[dir='rtl'] .dropdown-icon {\n  margin-right: 0.5rem;\n}\n\n.mod-caret-up {\n  -webkit-transform: rotate(180deg);\n      -ms-transform: rotate(180deg);\n          transform: rotate(180deg);\n  padding-bottom: 0;\n  padding-top: 0.2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown": `dropdown_dropdown_fEG8z`,
	"mod-open": `dropdown_mod-open_Dnwvi`,
	"modOpen": `dropdown_mod-open_Dnwvi`,
	"dropdown-icon": `dropdown_dropdown-icon_OMoXu`,
	"dropdownIcon": `dropdown_dropdown-icon_OMoXu`,
	"mod-caret-up": `dropdown_mod-caret-up_NUicY`,
	"modCaretUp": `dropdown_mod-caret-up_NUicY`
};
export default ___CSS_LOADER_EXPORT___;
